import { TrackingPayload } from './types'

function useAlgoliaTracking () {
  const ALGOLIA_QUERY_ID_KEY = 'algoliaQueryID'
  const isSearchPage = window.location.pathname.includes('/search')

  const trackingSendClick = (instance: any, payload: TrackingPayload) => {
    if (payload?.queryID) {
      setTrackingQueryID(payload.queryID)
    }

    if (instance?.sendEvents) {
      instance.sendEvents(payload, 'click', 'clickedObjectIDsAfterSearch')
    }
  }

  const trackingSendClickObjectIDs = (instance: any, payload: TrackingPayload) => {
    if (instance?.sendEvents) {
      instance.sendEvents(payload, 'click', 'clickedObjectIDs')
    }
  }

  const trackingSendView = (instance: any, payload: TrackingPayload) => {
    if (instance?.sendEvents) {
      instance.sendEvents(payload, 'viewed', 'viewedObjectIDs')
    }
  }

  const trackingSendConvertedAddToCart = (instance: any, payload: TrackingPayload) => {
    const eventName = !isSearchPage ? 'convertedObjectIDs' : 'convertedObjectIDsAfterSearch'

    if (instance?.sendEvents) {
      instance.sendEvents(payload, 'atc', eventName)
    }

    if (localStorage.getItem(ALGOLIA_QUERY_ID_KEY)) {
      localStorage.removeItem(ALGOLIA_QUERY_ID_KEY)
    }
  }

  const trackingSendAddedToCart = (instance: any, payload: TrackingPayload) => {
    const eventName = !isSearchPage ? 'addedToCartObjectIDs' : 'addedToCartObjectIDsAfterSearch'

    if (instance?.sendEvents) {
      instance.sendEvents(payload, 'added', eventName)
    }
  }

  const setTrackingQueryID = (id: string) => {
    localStorage.setItem(ALGOLIA_QUERY_ID_KEY, id)
  }

  return {
    trackingSendClick,
    trackingSendClickObjectIDs,
    trackingSendView,
    trackingSendConvertedAddToCart,
    trackingSendAddedToCart
  }
}

export default useAlgoliaTracking
